var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"fancy-button bg-gradient1",on:{"click":_vm.onClick}},[_c('span',{staticStyle:{"pointer-events":"none"}},[_vm._t("default"),_vm._v(" "),_c('i',{staticClass:"material-icons-outlined"},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-430a0e4e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BasicButton.vue
// module id = null
// module chunks = 